import BuildIcon from '@/assets/img/build1.svg';
import AnalyzeIcon from '@/assets/img/analysis1.svg';
import CreateIcon from '@/assets/img/data-nodes1.svg';
import WorkshopsIcon from '@/assets/img/teaching1.svg';
import ConsultingIcon from '@/assets/img/reports1.svg';

export default [
  {
    uid:"create",
    label: "Create",
    description:'Environmental Monitoring Programs',
    details: "**Environmental Monitoring Programs** - Tall Oaks has a unique blend of expertise in ecology, data analysis, and statistics. This expertise supports the creation of custom environmental monitoring programs and study designs. We can help find meaningful and statistically significant results to address your project needs.",
    image:"data-nodes1.png",
    icon: CreateIcon,
    tags: ["monitoring"]
  },
  {
    uid:"analyze",
    label: "Analysis",
    description:'Environmental Data Analysis',
    details: "**Data Analysis Services** - Tall Oaks can join at any point in your data journey to design, build, and evaluate predictive models and other analysis needs. We combine deep, statistical understanding and extensive data analysis experience. Tall Oaks helps your organization to examine and decipher your data so that you can be confident in your conclusions.",
    image:"analysis1.png",
    icon: AnalyzeIcon,
    tags: ["statistics","code","environmental"]
  },
  {
    uid:"build",
    label: "Build",
    description:'Environmental Data Management Products',
    details: "**Data Management Products** - Tall Oaks builds innovative, dynamic web applications utilizing the latest technologies. These applications provide a superior level of data management and an intuitive, featureful user interface for your customers.",
    image: "build1.png",
    icon: BuildIcon,
    tags: ["data management","acorns"]
  },
  {
    uid:"workshops",
    label: "Workshops",
    description:'Environmental Data Science + R Language',
    details: "__Data Science + R Language__ - Tall Oaks offers on-site and remote workshops tailored to the use cases of your organization and experience of your staff. Taught by Christian Parker who has more than a decade of experience applying R to solve statistical problems across fields and industries such as stream ecology, air quality, oil and gas, conservation management. Workshops can include custom R packages/libraries for your data visualization, data analysis needs, and other functions you want to learn and develop.",
    image:"teaching1.png",
    icon: WorkshopsIcon,
    tags: ["statistics","code"]
  },
  {

    uid:"consulting",
    label: "Consulting",
    description:'Custom Consulting',
    details: "**Custom Consulting** - Tall Oaks is able to tailor its services to your organization’s needs. Please reach out with questions related to anything at the intersection of data and the environment so that our team can create a custom consulting experience for you.",
    image:"reports1.png",
    icon: ConsultingIcon,
    tags: []
  },
].map( d => ({ ...d, route: `/services#${d.uid}` }));
